import { useCallback } from "react";
import { useUI } from "state";
import { handlePreviewDocument } from "components/DocumentPreviewer/DocumentPreviewer";

/**
 * Standard hook for opening the document preview modal
 */
export default function useDocumentPreview() {
  const { openModal, closeModal } = useUI();

  const openPreview = useCallback(
    (url: string) => {
      handlePreviewDocument({
        document: { url },
        openModal,
        closeModal,
      });
    },
    [openModal, closeModal],
  );

  return { openPreview };
}
